// [이 내용으로 상담하기] — AI 결과(+추천 차량 예상 운임·단계별 소요시간)를 실시간문의 첫 글 초안으로 만든다. 고객이 보내기 전에 고칠 수 있다
const won = (n) => `${Number(n).toLocaleString('ko-KR')}원`;

export default function consultDraft(result, compare) {
  if (!result) return '';
  const items = (result.items || [])
    .map((it) => `${it.name} ${it.qty}개${it.size ? `(${it.size})` : ''}${it.fragile ? ' 파손주의' : ''}`)
    .join(', ');
  const row = compare && Array.isArray(compare.rows) ? compare.rows.find((r) => r.vehicle === result.vehicle) : null;
  const fare = row && row.payable && row.total ? ` · 예상 운임 ${won(row.total)}` : '';
  const tl = row && row.timeline;
  const hhmm = (iso) => { const d = new Date(iso); return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`; };
  const time = tl && tl.totalMin ? `예상 소요: 약 ${tl.totalMin[0]}~${tl.totalMin[1]}분${tl.totalKm != null ? ` · 총 약 ${tl.totalKm}km` : ''}${tl.eta && tl.eta.length === 2 ? ` (지금 접수 시 ${hhmm(tl.eta[0])}~${hhmm(tl.eta[1])} 도착)` : ''}` : '';
  return [
    '[AI 차량 확인 결과로 문의드려요]',
    items && `물품: ${items}`,
    result.vehicle && `추천 차량: ${result.vehicle}${fare}`,
    time,
    result.summary && `요약: ${result.summary}`,
    '이 내용으로 접수 상담 부탁드립니다.',
  ].filter(Boolean).join('\n');
}
